import React from 'react';
import styled from "styled-components";

const StyledInbox = styled.div`
    display: flex;
    flex-direction: column; 
    margin-bottom: 80px; 
    border-radius: 10px; 
    padding: 1px 1px; 
    background-color: #F5F5F5;
    border-top: 1px solid #E6E6E6; 
    border-left: 1px solid #E6E6E6; 
    border-right: 1px solid #E6E6E6; 
`;

const CheckboxCol = styled.div`
    flex: 0.6
    div.checkbox{
        width: 20px;
        height: 20px;
        color: #6C6C6C;
        border: solid 1px;
        @media (max-width: 1000px){
            display: none;
        }
    }
`
const Sender = styled.div`
    flex: 1
    align-self: flex-start;
    overflow-x:hidden;
    margin-right: 24px; 
`
const Subject = styled.div`
    flex: 3;
    // min-width: 320px;
    overflow-x:hidden;
    margin-right: 20px; 
    @media (max-width: 1000px){
        color: #909090;
    }
`
const Time = styled.div`
    flex: 0.6;
    width: auto; 
    font-size: 14px; 
    color: #6C6C6C;
    text-align: right;
    @media (max-width: 1000px){
        position: absolute;
        top: 0; 
        right: 0; 
        margin: 8px 16px 0px 0px; 
    }
`
const StyledMail = styled.div`
    display: flex;
    flex-direction: row; 
    justify-content: space-between;
    white-space: nowrap;
    padding: 12px 20px; 
    background-color: #f5f5f5;
    border-bottom: 1px solid #E6E6E6; 
    overflow: hidden;
    @media (max-width: 1000px){
        position: relative;
        flex-direction: column;
    }
    background-color: ${
        props => props.status ?
            "#F5F5F5" :
            "#FFF"
    };    
`;


class Mail extends React.Component{
    // handleClick = () => {
    //     //need these to be passed in as props
    //     const { path, onItemClick } = this.props;
    //     onItemClick(path);
    // }

    render(){
        /*gets the active variable out of NavItem's props*/
        var { read } = this.props;
        if (this.props.subject == "Your prognosis data has been loaded"){
            read = false; 
        }
        return (
            <StyledMail status={read}>
                <CheckboxCol><div className="checkbox"></div></CheckboxCol>
                <Sender>{this.props.sender}</Sender>
                <Subject>{this.props.subject}</Subject>
                <Time>{this.props.time}</Time>
            </StyledMail>
        );
    }
}

class Inbox extends React.Component {
    constructor(props){
        super(props); 
        this.state = {
            read: true,
            items: [
                {
                    sender: 'CINJ',
                    subject: 'Your prognosis data has been loaded',
                    time: '12:18PM',
                    content: "Your prognosis data has been loaded. Click on Prognosis to view it.",
                    key: 1,
                },
                {
                    sender: 'Dr. Fields',
                    subject: 'Following up',
                    time: 'Apr 18',
                    content: "Just wanted to check and see how you were doing with the new tool. Hope everything is well.",
                    key: 2
                },
                {
                    sender: 'Nurse',
                    subject: 'Here to support you',
                    time: 'Apr 18',
                    content: "Please call me anytime you have a question.",
                    key: 3
                },
                {
                    sender: 'CINJ',
                    subject: 'Welcome!',
                    time: 'Apr 18',
                    content: "Welcome to your new tool! Check out the tutorial here.",
                    key: 4
                },
            ]
        }
    }

    // onItemClick = (path) => {
    //     /*change the activePath by setting the state*/
    //     this.setState ({activePath: path}); /*Sets activePath causing rerender causing CSS to change*/
    // }

    render() {
        const {read, items} = this.state;

        return (
            <StyledInbox>
                {
                    items.map((item) => {
                        /*Return NavItems*/
                        return (
                            <Mail sender = {item.sender} subject={item.subject} 
                            time={item.time} content = {item.content} read={read}></Mail>
                        )
                    })
                }
            </StyledInbox>
        );
      }
}

export default class InboxClass extends React.Component {
    render() {
      return (
          <Inbox></Inbox>
      );
    }
  }